import ProjectHeader from "../../components/common/ProjectHeader/ProjectHeader"
import { useNavigate } from "react-router-dom";
import { useParams } from "react-router-dom";
import { useState } from "react";
import { useEffect } from "react";
import Flower from "../../components/common/Flower/Flower";
import ClickFlower from "../../components/common/ClickFlower/ClickFlower";
import { Link } from "react-router-dom";
import { IoIosArrowBack } from "react-icons/io";
import ChapterSettings from "../../components/projectSettings/ChaptersSettings/ChaptersSettings";
import { FaEdit, FaCheck } from "react-icons/fa";
import { MdDelete } from "react-icons/md";
import { supabase } from "../../supabase";
import DailyGoalSettings from "../../components/projectSettings/DailyGoalSettings/DailyGoalSettings";
import { StaticGoalCalculate } from "../../functions/getStreak";
import DeleteProjectModal from "../../components/projectSettings/DeleteProjectModal/DeleteProjectModal";



export default function OnlineSetting() {
    const navigate = useNavigate();
    const { id } = useParams(); 
    
    const [project, setProject] = useState(null);
    
    const [ChaptersEnabled, setChapterEnabled] = useState(false);
    const [minWords, setMinimum] = useState(0);
    
    const [GoalEnabled, setGoalEnabled] = useState(false);
    const [GoalMode, setGoalMode] = useState("Auto");
    const [GoalValue, setGoalValue] = useState(0);
    const [ShouldRecalculate, setRecalculate] = useState(false);
    
    const[showModal, setShowModal] = useState(false);

    const deleteProject = async () => {
        const { error } = await supabase.from("projects").delete().eq("id", project.id);
        if (error) console.error(error);
    };

    useEffect(() => {
        async function fetchProject() {
          const { data, error } = await supabase
            .from("projects")
            .select("*")
            .eq("id", id)
            .single();
    
          if (error) {
            console.error(error);
            return;
          }
          setProject(data);
          
        }
    
        fetchProject();
    }, [id]);

    useEffect(() => {
        if (!project) return;
    
        setChapterEnabled(project.settings.chaptersEnabled);
        setMinimum(project.settings.MinimumWordsInChapter);
    
        setGoalEnabled(project.settings.goalEnabled);
        setGoalMode(project.settings.goalMode);
    
        if (project.settings.goalMode !== "Static") {
        setGoalValue(project.settings.dailyGoal);
        }
      }, [project]);

      const EditProject= async ()=>{
        let finalGoalValue = GoalValue;
        if(GoalMode == "Static" || GoalMode == "Auto"){
            finalGoalValue = StaticGoalCalculate(project);
            setGoalValue(finalGoalValue);
        }

        const { error } = await supabase
            .from("projects")
            .update({
                settings: {
                ...project.settings,
                chaptersEnabled: ChaptersEnabled,
                MinimumWordsInChapter: minWords,
                goalEnabled: GoalEnabled,
                goalMode: GoalMode,
                dailyGoal: finalGoalValue,
                }
            })
            .eq("id", project.id);

            navigate(`/online/project/${id}`);
      }

    return (
        <div className="projectlist-wrapper">
            <ProjectHeader
                    headerTitle={'Ustawienia'}
                    showBackButton={true}
                    path={`/online/project/${id}`}
            />

            <div className="SettingsForm" style={{marginTop: '100px'}}>
                <div className="section"> 
                    <ChapterSettings
                    ChaptersEnabled={ChaptersEnabled}
                    setChaptersEnabled={setChapterEnabled}
                    minWords={minWords}
                    setMinimum={setMinimum}
                    />
                </div>

                <div className="section"> 
                    <DailyGoalSettings
                    GoalEnabled={GoalEnabled}
                    setGoalEnabled={setGoalEnabled}
                    GoalMode={GoalMode}
                    setGoalMode={setGoalMode}
                    GoalValue={GoalValue}
                    setGoalValue={setGoalValue}
                    setRecalculate={setRecalculate}
                    onRefresh={() => {
                        const calculatedGoal = StaticGoalCalculate(project);
                        setGoalValue(calculatedGoal);
                    }}
                    />
                </div>

                <div className="buttons-row">
                    <button 
                        onClick={() => setShowModal(true)} >
                        <MdDelete/> Usuń projekt
                    </button>
                    <button> <FaEdit/> Edytuj projekt </button>
                    <button onClick={EditProject}> <FaCheck/> Zatwierdź zmiany </button>
                </div>
            {showModal && (

                <DeleteProjectModal
                    setShowModal={setShowModal}
                    onDelete={ async ()=>{
                        setShowModal(false);
                        deleteProject();
                        navigate(`/online`);
                    }}
                />
            
            )}
            </div>
        
        <Link to={`/online/project/${id}`} className="BackfixButton"><IoIosArrowBack /></Link>

        <Flower
          flowerClass={"flower1"}/>
        <Flower
          flowerClass={"flower2"}/>
        <ClickFlower/>
        </div>
    )
}